export default __webpack_public_path__ + "static/media/arabic_white.984a5913.svg";